// Pre-lander for traffic whose ad may not show the price (Apex / Facebook): ?prelander=1 opens the landing
// page on "Your game is loading up" with the price at the foot, then moves to JOIN by itself, so the price
// is seen twice before consent (design "Turn 4", BruceK / WASPA 19 Oct 2026). Links without the parameter
// (Google, TikTok) open on JOIN as before. Same page load: no redirect or extra asset, and the attribution,
// ext_ref, /he call and Evina kit all carry over to JOIN.
// The minimum time the pre-lander is ON SCREEN (loaded, tab in front, painted; background time does not
// count), and only after our fraud check passed (components/PreLander.vue).
export const PRELANDER_MIN_MS = 2000
// Held past that only while the visitor is still being identified, up to this much on-screen time (JOIN's
// own spinner covers anything left). Never a way round the fraud check or the visibility rules.
export const PRELANDER_MAX_MS = 3000
// Longest wait for the art and fonts before the page counts as loaded: the price text is on screen anyway.
export const PRELANDER_LOAD_WAIT_MS = 5000
// Status lines switch where the design's keyframes do (line 1 out by 34%, line 2 by 67% of two seconds),
// on on-screen time.
export const PRELANDER_STATUS_MS = [560, 1220]
// "Ready." stays on screen this long before JOIN replaces it.
export const PRELANDER_READY_BEAT_MS = 500

export function prelanderRequested() {
  const value = new URLSearchParams(window.location.search).get('prelander')
  return value !== null && !/^(0|false|no|off)$/i.test(value)
}
